import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import PathwaysPage from "./pages/PathwaysPage";
import ProgramsPage from "./pages/ProgramsPage";
import ResourcesPage from "./pages/ResourcesPage";
import CareerPlanningPage from "./pages/CareerPlanningPage";
import TestPrepPage from "./pages/TestPrepPage";
import CollegeAdmissionsPage from "./pages/CollegeAdmissionsPage";
import StudentAidPage from "./pages/StudentAidPage";
import AboutPage from "./pages/AboutPage";
import FAQPage from "./pages/FAQPage";
import ContactPage from "./pages/ContactPage";
import LoginPage from "./pages/LoginPage";
import RecruiterSignupPage from "./pages/RecruiterSignupPage";
import SetPasswordPage from "./pages/SetPasswordPage";
import RecruiterDashboard from "./pages/RecruiterDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import StudentDashboard from "./pages/StudentDashboard";
import CreateStudentProfile from "./pages/CreateStudentProfile";
import AdminLogin from "./pages/AdminLogin";
import RecruiterLogin from "./pages/RecruiterLogin";
import StudentLogin from "./pages/StudentLogin";
import StaffLogin from "./pages/StaffLogin";
import StaffDashboard from "./pages/StaffDashboard";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import StudentSignup from "./pages/StudentSignup";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import { Toaster } from "./components/ui/sonner";
import NotificationPoller from "./components/NotificationPoller";
import NotificationBell from "./components/NotificationBell";

// Routes that render their own chrome (no marketing header/footer).
const DASHBOARD_PREFIXES = [
  "/admin-dashboard",
  "/recruiter-dashboard",
  "/student-portal",
  "/create-student",
  "/staff-dashboard",
];

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function ChromeLayout() {
  const { pathname } = useLocation();
  const isDashboard = DASHBOARD_PREFIXES.some((p) => pathname.startsWith(p));

  return (
    <>
      <ScrollToTop />
      {!isDashboard && <Header />}
      {isDashboard && <NotificationBell />}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/pathways" element={<PathwaysPage />} />
        <Route path="/programs" element={<ProgramsPage />} />
        <Route path="/resources" element={<ResourcesPage />} />
        <Route path="/career-planning" element={<CareerPlanningPage />} />
        <Route path="/test-prep" element={<TestPrepPage />} />
        <Route path="/college-admissions" element={<CollegeAdmissionsPage />} />
        <Route path="/student-aid" element={<StudentAidPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />

        {/* Portal Routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/recruiter-login" element={<RecruiterLogin />} />
        <Route path="/student-login" element={<StudentLogin />} />
        <Route path="/staff-login" element={<StaffLogin />} />
        <Route path="/staff-dashboard" element={<StaffDashboard />} />
        <Route path="/recruiter-signup" element={<RecruiterSignupPage />} />
        <Route path="/set-password" element={<SetPasswordPage />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/student-signup" element={<StudentSignup />} />
        <Route path="/recruiter-dashboard" element={<RecruiterDashboard />} />
        <Route path="/student-portal" element={<StudentDashboard />} />
        <Route path="/admin-dashboard" element={<AdminDashboard />} />
        <Route path="/create-student" element={<CreateStudentProfile />} />
      </Routes>
      {!isDashboard && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ChromeLayout />
        <NotificationPoller />
        <Toaster richColors position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
